import { BRAND } from "./data";
import { Reveal } from "./Reveal";
import { useContent } from "./ContentContext";
import { useTx, txtStyle } from "./siteText";
import { useLightbox } from "./Lightbox";

export const Signatures = () => {
  const { settings, resolveImg } = useContent();
  const tx = useTx();
  const { show } = useLightbox();
  const sigs = settings.signatures || [];
  return (
    <section id="signatures" className="relative py-24 md:py-32 bg-cantina-alt" data-testid="signatures-section">
      <div className="absolute inset-0 tile-watermark opacity-[0.04]" />
      <div className="relative max-w-[1400px] mx-auto px-6 md:px-10">
        <Reveal className="text-center flex flex-col items-center mb-16">
          <p className="font-script text-cantina-terracotta mb-2" style={txtStyle(tx("signatures.eyebrow"))}>{tx("signatures.eyebrow").text}</p>
          <h2 className="font-display tracking-tight text-cantina-ink leading-tight" style={txtStyle(tx("signatures.heading"))}>{tx("signatures.heading").text}</h2>
          <div className="dash-rule w-28 mt-6" />
        </Reveal>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {sigs.map((item, i) => (
            <Reveal key={i} delay={i * 0.12}>
              <article className="dish-card group h-full flex flex-col bg-cantina-surface rounded-3xl border border-cantina-line overflow-hidden shadow-[0_10px_30px_rgba(23,35,59,0.05)]" data-testid={`signature-card-${i}`}>
                <button onClick={() => show(sigs, i)} className="frame-img aspect-[5/4] relative cursor-zoom-in block w-full text-left" data-testid={`signature-img-${i}`} aria-label={`View ${item.name}`}>
                  <img src={resolveImg(item.img)} alt={item.name} className="w-full h-full object-cover" />
                  <span className="absolute top-4 left-4 font-sans tracking-widest uppercase text-white px-3 py-1.5 rounded-full" style={{ backgroundColor: item.color || "#0047AB", ...txtStyle(tx("signatures.cardKicker")) }}>
                    {item.kicker}
                  </span>
                </button>
                <div className="p-7 flex flex-col flex-1">
                  <h3 className="font-display text-cantina-ink mb-2" style={txtStyle(tx("signatures.cardTitle"))}>{item.name}</h3>
                  <p className="font-sans leading-relaxed text-cantina-ink/65 mb-6 flex-1" style={txtStyle(tx("signatures.cardDesc"))}>{item.desc}</p>
                  <a href={BRAND.orderUrl} target="_blank" rel="noopener noreferrer" className="nav-link self-start font-sans" style={{ color: item.color || "#0047AB", ...txtStyle(tx("signatures.orderLabel")) }} data-testid={`signature-order-${i}`}>
                    {tx("signatures.orderLabel").text}
                  </a>
                </div>
              </article>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
};
